export default __webpack_public_path__ + "static/thirdSectionImg-9ff122ce5d6078ce45b620d9603c1cf1.png";